import React, {FC} from 'react';
import HLModal from '../../shared/components/modal/HLModal';
import HLButton, {HLButtonStyleType} from '../../shared/components/button/HLButton';
import {bulkCreateLessonsFetch} from "../../app/axios/lessonFetches";
import {useForm} from "react-hook-form";
import {LessonBulkCreateRequest} from "../../shared/types/lesson";
import HLErrorMessage from "../../shared/components/error-message/HLErrorMessage";
import HLFormInput from "../../shared/components/input/HLFormInput";
import {processFormServerError} from "../../shared/utils/processFormServerError";
import LessonDateSelector from "../../components/selector/LessonDateSelector";

interface CreateLessonsModalProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    agreementId: string | undefined;
    onSuccess: () => void
}

const UserCreateLessonsModal: FC<CreateLessonsModalProps> = (
    {
        open,
        setOpen,
        agreementId,
        onSuccess
    }) => {
    const {
        register,
        handleSubmit,
        reset,
        setError,
        clearErrors,
        setValue,
        watch,
        formState: {errors, isSubmitting}
    } = useForm<LessonBulkCreateRequest>()

    const bulkCreateLessons = async (request: LessonBulkCreateRequest) => {
        try {
            await bulkCreateLessonsFetch(request);
            closeModal()
            onSuccess()
        } catch (err: any) {
            processFormServerError(err, setError);
        }
    }

    const closeModal = () => {
        reset()
        setOpen(false)
    }

    return (
        <HLModal open={open} onClose={closeModal} title="Создать уроки">
            <form onSubmit={handleSubmit(bulkCreateLessons)} className="columnContainer">
                <HLErrorMessage error={errors.root?.message}/>

                <HLFormInput
                    id="agreementId"
                    {...register('agreementId', {
                        required: 'Идентификатор договора обязателен'
                    })}
                    value={agreementId}
                    hidden={true}
                />

                <LessonDateSelector
                    register={register}
                    setError={setError}
                    clearErrors={clearErrors}
                    setValue={setValue}
                    watch={watch}
                    errors={errors}
                />

                <div className="inlineContainer">
                    <HLButton
                        type="submit"
                        disabled={isSubmitting}
                    >
                        Создать
                    </HLButton>
                    <HLButton
                        type="button"
                        onClick={closeModal}
                        styleType={HLButtonStyleType.GRAY}
                    >
                        Отмена
                    </HLButton>
                </div>
            </form>
        </HLModal>
    );
};

export default UserCreateLessonsModal;